import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { InterconnectHome } from '../Interconnect';
import { fetchProjectDetailsData, getProjectDetails } from '../../app/projects/projectDetailsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { PreApp } from '../PreApplication';
const ProjectUpdate = (props) => {
  const dispatch = useDispatch();
  const { projectViewSt } = props;
  const detailsData = useSelector(getProjectDetails);

  useEffect(() => {
    //Calling Details API
    if (projectViewSt) {
      const requestObj = {AppNb:projectViewSt.data?.appNb, CPRProjectNb: projectViewSt.data?.cprProjectNb };
      dispatch(fetchProjectDetailsData(requestObj));
    }
  }, []);

  return (
    <Card style={{ padding: '10px' }}>
      <Card.Header style={{ background: '#f3f3f3' }}>
        <span
          style={{ color: '#013a6b' }}
          onClick={() => {
            props.setShowProjectView({ show: false, data: {} });
          }}
        >
          <FontAwesomeIcon
            style={{ color: '#013a6b' }}
            icon={['fas', 'chevron-left']}
            size="lg"
          />{' '}
          <b>Back</b>
          </span>
          <Form.Text style={{float:'right'}}>
            {detailsData?.appEnrollmentSummary?.cprProjectNb && (<>Project Number: <span style={{fontWeight:'bold'}}>{detailsData?.appEnrollmentSummary?.cprProjectNb}</span> </>)}
            <br/>
            {detailsData?.appEnrollmentSummary?.customer?.premiseNb && (<>Premise Number: <span style={{fontWeight:'bold'}}>{detailsData?.appEnrollmentSummary?.customer?.premiseNb}</span> </>)}
           
            </Form.Text>
      </Card.Header>
      <br />     
      {projectViewSt.data?.appType==='Interconnect'?
      <InterconnectHome isClickable pageType={projectViewSt.btnType} detailsData={detailsData}/>
      :
      <PreApp isClickable pageType={projectViewSt.btnType} detailsData={detailsData}/>}
    </Card>
  );
};

export default ProjectUpdate;
